import { tracker as CLICKSTREAM } from '@zg-rentals/clickstream';
import { tracker as GTM } from '@zg-rentals/google-tag-manager';
import { defineAnalytics } from '@zg-rentals/rentals-analytics';

import type { ClickstreamPayload, ZrmListingInfo, ZrmUserInfo } from '@zg-rentals/clickstream';

// The host app owns initialization; this only needs the shared tracker singletons.
const analytics = defineAnalytics({ CLICKSTREAM, GTM });

const trackUserEvent = analytics.createTrackEvent<'CLICKSTREAM', ClickstreamPayload<ZrmUserInfo>>('CLICKSTREAM');
const trackListingUserEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  ClickstreamPayload<ZrmListingInfo & ZrmUserInfo>
>('CLICKSTREAM');

export const trackEvent = {
  user: trackUserEvent,
  listingUser: trackListingUserEvent,
};

export const trackGtmEvent = analytics.createTrackEvent('GTM');
